var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAuthenticatorAppmin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7542E5",
    d: "M29.2 8c0-1.35-.05-2.85-.05-4.55 0-.7-.5-1.3-1.2-1.45L16.4 0h-.5L4.35 2c-.7.15-1.25.75-1.2 1.45 0 1.7 0 3.2-.05 4.55-.05 2.4-.05 4.15.05 5.2.65 6.9 2.1 10.1 4.6 13.5 2 2.7 4.9 4.55 8.15 5.25.1 0 .2.05.3.05s.2 0 .3-.05c3.25-.7 6.15-2.55 8.15-5.25 2.5-3.4 3.95-6.55 4.55-13.5.05-1.1.05-2.8 0-5.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7542E5",
    d: "m15.9.05-11.55 2c-.7.1-1.2.7-1.2 1.4 0 1.7-.05 3.2-.05 4.55-.05 2.4-.05 4.15.05 5.2.65 6.95 2.1 10.1 4.55 13.5 2 2.7 4.9 4.55 8.15 5.25.1 0 .2.05.3.05V0c-.1 0-.15 0-.25.05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7542E5",
    d: "M15.95 2.25 6.25 3.9c-.6.1-1 .6-1 1.2 0 1.45 0 2.7-.05 3.8-.05 2-.05 3.5.05 4.35.5 5.8 1.75 8.5 3.8 11.35 1.65 2.25 4.1 3.85 6.85 4.4h.25V2.2c-.05 0-.15 0-.2.05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0090ED",
    d: "M27.1 8.9c0-1.1-.05-2.4-.05-3.8 0-.6-.4-1.1-1-1.2l-9.7-1.65h-.2v26.8h.25c2.75-.6 5.2-2.15 6.85-4.45 2.1-2.85 3.3-5.5 3.85-11.35q.075-1.275 0-4.35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7542E5",
    d: "M29.2 8c0-1.35-.05-2.85-.05-4.55 0-.7-.5-1.3-1.2-1.45L16.4 0h-.5L4.35 2c-.7.15-1.25.75-1.2 1.45 0 1.7 0 3.2-.05 4.55-.05 2.4-.05 4.15.05 5.2.65 6.9 2.1 10.1 4.6 13.5 2 2.7 4.9 4.55 8.15 5.25.1 0 .2.05.3.05s.2 0 .3-.05c3.25-.7 6.15-2.55 8.15-5.25 2.5-3.4 3.95-6.55 4.55-13.5.05-1.1.05-2.8 0-5.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7542E5",
    d: "m15.9.05-11.55 2c-.7.1-1.2.7-1.2 1.4 0 1.7-.05 3.2-.05 4.55-.05 2.4-.05 4.15.05 5.2.65 6.95 2.1 10.1 4.55 13.5 2 2.7 4.9 4.55 8.15 5.25.1 0 .2.05.3.05V0c-.1 0-.15 0-.25.05"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7542E5",
    d: "M15.95 2.25 6.25 3.9c-.6.1-1 .6-1 1.2 0 1.45 0 2.7-.05 3.8-.05 2-.05 3.5.05 4.35.5 5.8 1.75 8.5 3.8 11.35 1.65 2.25 4.1 3.85 6.85 4.4h.25V2.2c-.05 0-.15 0-.2.05"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0090ED",
    d: "M27.1 8.9c0-1.1-.05-2.4-.05-3.8 0-.6-.4-1.1-1-1.2l-9.7-1.65h-.2v26.8h.25c2.75-.6 5.2-2.15 6.85-4.45 2.1-2.85 3.3-5.5 3.85-11.35q.075-1.275 0-4.35"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAuthenticatorAppmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_authenticator_app.min.55f5b35904050b38df8dd7d8166eb20a.svg";